// IMPORTING APIS
import React from 'react';
import {
  Typography,
  useMediaQuery,
  Grid,
  Container,
  Divider,

} from '@material-ui/core';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import logo from '@assets/images/kumu-live-logo.png';
import facebook from '@assets/images/facebook.png';
import instagram from '@assets/images/instagram.png';
import twitter from '@assets/images/twitter.png';
import appstore from '@assets/images/app-store.png';
import playstore from '@assets/images/playstore.png';

import './Footer.css';
// LOCAL-STYLING
const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    fontFamily: 'CircularXX-Book',
  },
  title: {
    flexGrow: 1,
  },
  link: {
    color: '#FFFFF',
  },
}));

function Footer() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className={classes.root}>
      <Divider style={{ backgroundColor: 'white', opacity: 0.35 }} />
      <Container
        maxWidth={false}
        style={{
          paddingLeft: 0, paddingRight: 10, paddingTop: 30, paddingBottom: 10, height: 100, marginTop: 'auto',
        }}
      >
        {isMobile ? (
          <Grid container>
            <Grid item xs={12} style={{ paddingLeft: 10, paddingBottom: 20 }}>
              <a className='nav-link' style={{ paddingLeft: 0 }} href='/' rel='noreferrer'>
                <img className='logo' src={logo} alt='logo' width='80' height='auto' />
              </a>
              <Grid item xs={9} sm={9}>
                <Typography variant='body2' gutterBottom style={{ letterSpacing: 0.4, fontSize: 10, fontFamily: 'CircularXX-Book' }}>
                  Kumu is a Filipino community live stream platform where you can just hang out,
                  explore the many livestreams the Kumunity has to offer,
                  meet and chat with fellow Filipinos all around the world.
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container style={{ paddingTop: 10 }}>
                <Grid item xs={6} className='socials' style={{ paddingLeft: 10, paddingBottom: 20 }}>
                  <Typography className='footer-titles' style={{ paddingBottom: 10, fontSize: 12, fontFamily: 'CircularXX-Book' }}>FOLLOW US ON</Typography>
                  <Grid container justifyContent='flex-start'>
                    <a href='https://facebook.com/kumuph' target='_blank' rel='noreferrer' style={{ paddingTop: 2, marginRight: 5 }}>
                      <img className='logo' src={facebook} alt='logo' width='32' height='auto' />
                    </a>
                    <a href='https://instagram.com/kumuph' target='_blank' rel='noreferrer' style={{ alignContent: 'center', marginRight: 5, paddingTop: 2 }}>
                      <img className='logo' src={instagram} alt='logo' width='34' height='auto' />
                    </a>
                    <a href='https://twitter.com/kumuph' target='_blank' rel='noreferrer' style={{ paddingTop: 2 }}>
                      <img className='logo' src={twitter} alt='logo' width='34' height='auto' />
                    </a>
                  </Grid>
                </Grid>

                <Grid item xs={12} style={{ paddingLeft: 10, paddingTop: 10 }}>
                  <Typography className='footer-titles' style={{ fontSize: 12, fontFamily: 'CircularXX-Book' }}>DOWNLOAD THE KUMU APP</Typography>
                  <Grid container style={{ paddingTop: 10 }}>
                    <a style={{ paddingLeft: 0, paddingRight: 5 }} href='https://apps.apple.com/us/app/kumu-live-videos-and-games/id1299040762' target='_blank' rel='noreferrer'>
                      <img className='logo' src={appstore} alt='appstore' width='100' height='auto' />
                    </a>
                    <a style={{ paddingLeft: 0 }} href='https://play.google.com/store/apps/details?id=im.kumu.ph&hl=en&gl=US' target='_blank' rel='noreferrer'>
                      <img className='logo' src={playstore} alt='playstore' width='100' height='auto' />
                    </a>
                  </Grid>
                  <Grid container align='center' style={{ paddingTop: 20 }}>
                    <Grid item xs={12} style={{ paddingRight: 10, lineHeight: 1 }}>
                      <Typography variant='caption' style={{ fontSize: 12, paddingRight: 10, fontFamily: 'CircularXX-Book' }}>
                        <a style={{ paddingLeft: 0 }} href='https://kumu.ph/terms-of-use' target='_blank' rel='noreferrer'>Terms of Use</a>
                        {' '}
                        |
                        <a style={{ paddingLeft: 0 }} href='https://kumu.ph/privacy-policy' target='_blank' rel='noreferrer'>Privacy Policy</a>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ paddingRight: 10, lineHeight: 1 }}>
                      <Typography variant='caption' style={{ fontSize: 12, paddingRight: 10, fontFamily: 'CircularXX-Book' }}>© 2021, Kumu Live</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ paddingLeft: 12, paddingRight: 5 }}>
            <Grid item md={5} style={{ paddingLeft: 12 }}>
              <a className='nav-link' href='/' rel='noreferrer' style={{ paddingLeft: 0 }}>
                <img className='logo' src={logo} alt='logo' width='75' />
              </a>
              <Grid item md={5}>
                <Typography variant='body2' gutterBottom style={{ letterSpacing: 0.4, fontSize: 10, fontFamily: 'CircularXX-Book' }}>
                  Kumu is a Filipino community live stream platform where you can just hang out,
                  explore the many livestreams the Kumunity has to offer,
                  meet and chat with fellow Filipinos all around the world.
                </Typography>
              </Grid>
            </Grid>

            <Grid item md={2}>
              <Grid container justifyContent='center' align='right'>
                <Grid item className='socials'>
                  <Typography align='center' className='footer-titles' style={{ paddingBottom: 10, fontSize: 14, fontFamily: 'CircularXX-Book' }}>FOLLOW US ON</Typography>
                  <Grid container justifyContent='center'>
                    <a href='https://facebook.com/kumuph' target='_blank' rel='noreferrer' style={{ paddingTop: 2, marginRight: 5 }}>
                      <img className='logo' src={facebook} alt='logo' width='28' />
                    </a>
                    <a href='https://instagram.com/kumuph' target='_blank' rel='noreferrer' style={{ alignContent: 'center', marginRight: 5, paddingTop: 2 }}>
                      <img className='logo' src={instagram} alt='logo' width='29' />
                    </a>
                    <a href='https://twitter.com/kumuph' target='_blank' rel='noreferrer' style={{ paddingTop: 2 }}>
                      <img className='logo' src={twitter} alt='logo' width='29' />
                    </a>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item md={5}>
              <Grid container>
                <Grid container item align='right' justifyContent='flex-end' style={{ paddingRight: 10 }}>
                  <Typography className='footer-titles' style={{ fontSize: 14, fontFamily: 'CircularXX-Book' }}>DOWNLOAD THE KUMU APP</Typography>
                  <Grid container justifyContent='flex-end' style={{ paddingTop: 10 }}>
                    <a className='nav-link' style={{ paddingLeft: 0, paddingRight: 5 }} href='https://apps.apple.com/us/app/kumu-live-videos-and-games/id1299040762' target='_blank' rel='noreferrer'>
                      <img className='logo' src={appstore} alt='appstore' width='90' />
                    </a>
                    <a className='nav-link' style={{ paddingLeft: 0, paddingRight: 0 }} href='https://play.google.com/store/apps/details?id=im.kumu.ph&hl=en&gl=US' target='_blank' rel='noreferrer'>
                      <img className='logo' src={playstore} alt='playstore' width='90' />
                    </a>
                  </Grid>
                  <Grid container align='right' style={{ paddingTop: 20 }}>
                    <Grid item md={12} style={{ lineHeight: 1 }}>
                      <Typography variant='caption' style={{ fontSize: 10, fontFamily: 'CircularXX-Book' }}>
                        <a style={{ paddingLeft: 0 }} href='https://kumu.ph/terms-of-use' target='_blank' rel='noreferrer'>Terms of Use</a>
                        {' '}
                        |
                        <a style={{ paddingLeft: 0 }} href='https://kumu.ph/privacy-policy' target='_blank' rel='noreferrer'>Privacy Policy</a>
                      </Typography>
                    </Grid>
                    <Grid item md={12} style={{ lineHeight: 1 }}>
                      <Typography variant='caption' style={{ fontSize: 10, fontFamily: 'CircularXX-Book' }}>© 2021, Kumu Live</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
}

export default Footer;
